import React from 'react';
import { FormattedMessage, FormattedNumber, defineMessages } from 'react-intl';

import withReservation from '../utils/Reservation';
import Dropdown from './Dropdown';

const propTypes = {};

const messages = defineMessages({
  inputValue: {
    defaultMessage: '{value} Year Warranty',
    id: 'checkout.warranty.inputValue',
  },
  oneYear: {
    defaultMessage: '1 Year Warranty (Included)',
    id: 'checkout.warranty.oneYear',
  },
  twoYear: {
    defaultMessage: '2 Year Warranty (+{extendedWarranty2YearPrice})',
    id: 'checkout.warranty.twoYear',
  },
  threeYear: {
    defaultMessage: '3 Year Warranty (+{extendedWarranty3YearPrice})',
    id: 'checkout.warranty.threeYear',
  },
});

function WarrantyInput({ value = 1, id, onChange, cart, editable }) {
  const title = (
    <FormattedMessage {...messages.inputValue} values={{ value }} />
  );
  if (!editable) return <span>{title}</span>;

  const {
    extendedWarranty2YearPrice,
    extendedWarranty3YearPrice,
  } = cart.remote.inventory;

  return (
    <Dropdown title={title} id={id}>
      <Dropdown.Item onClick={() => onChange(1)} active={value === 1}>
        <FormattedMessage {...messages.oneYear} values={{ value }} />
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onChange(2)} active={value === 2}>
        <FormattedMessage
          {...messages.twoYear}
          values={{
            extendedWarranty2YearPrice: (
              <FormattedNumber
                value={extendedWarranty2YearPrice / 100}
                currency="USD"
                style="currency" // eslint-disable-line react/style-prop-object
                minimumFractionDigits={0}
                maximumFractionDigits={0}
              />
            ),
          }}
        />
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onChange(3)} active={value === 3}>
        <FormattedMessage
          {...messages.threeYear}
          values={{
            extendedWarranty3YearPrice: (
              <FormattedNumber
                value={extendedWarranty3YearPrice / 100}
                currency="USD"
                style="currency" // eslint-disable-line react/style-prop-object
                minimumFractionDigits={0}
                maximumFractionDigits={0}
              />
            ),
          }}
        />
      </Dropdown.Item>
    </Dropdown>
  );
}

WarrantyInput.propTypes = propTypes;

export default withReservation(WarrantyInput);
